/**
 * **Перечисления модуля советника Ensi Cloud Adviser**
 *
 * _Определяет константы и перечисления для работы с системой рекомендаций._
 *
 * @module adviser-enums
 */

/**
 * Типы блоков рекомендаций Ensi Cloud Adviser
 */
export enum AdviserBlockType {
  /** Искавшие также смотрели (по product_id) */
  PEOPLE_ALSO_SEARCH = "people_also_search",
  /** Искавшие также смотрели (по query) */
  SEARCHERS_ALSO_VIEWED = "searchers_also_viewed",
  /** С этим товаром покупают (Cross Sell) */
  CROSS_SELL = "cross_sell",
  /** Up Sell (более дорогие альтернативы) */
  UP_SELL = "up_sell",
  /** Up Sell (новая версия) */
  UP_SELL_NEW = "up_sell_new",
  /** Недавно просматривали */
  RECENTLY_WATCHED = "recently_watched",
  /** Популярные товары */
  POPULAR_PRODUCTS = "popular_products",
  /** Похожие товары */
  SIMILAR_PRODUCTS = "similar_products",
}

/**
 * Типы фильтров для рекомендаций
 */
export enum AdviserFilterType {
  /** По ID продукта */
  PRODUCT_ID = "product_id",
  /** По поисковому запросу */
  QUERY = "query",
  /** По ID клиента */
  CUSTOMER_ID = "customer_id",
  /** По ID локации */
  LOCATION_ID = "location_id",
}

/**
 * Типы сортировки
 */
export enum AdviserSortType {
  /** По релевантности */
  RELEVANCE = "relevance",
  /** По названию */
  NAME = "name",
  /** По цене */
  PRICE = "price",
  /** По популярности */
  POPULARITY = "popularity",
  /** По дате */
  DATE = "date",
}

/**
 * Статусы загрузки
 */
export enum LoadingStatus {
  /** Не загружается */
  IDLE = "idle",
  /** Загружается */
  LOADING = "loading",
  /** Загружено успешно */
  SUCCESS = "success",
  /** Ошибка загрузки */
  ERROR = "error",
}

/**
 * Типы включений в ответ
 */
export enum IncludeType {
  /** Свойства товаров */
  PROPERTIES = "properties",
}
